// extracted by mini-css-extract-plugin
export var actionButton = "_nm-0";
export var actionMenuContainer = "_nm-i";
export var bubble = "_nm-2";
export var bubbleActionMenu = "_nm-j";
export var bubbleContext = "_nm-6";
export var bubbleItems = "_nm-7";
export var customer = "_nm-3";
export var divider = "_nm-8";
export var fileList = "_nm-9";
export var hiddenComment = "_nm-o";
export var infoAbove = "_nm-a";
export var internal = "_nm-4";
export var lightActionButton = "_nm-1";
export var link = "_nm-b";
export var merchant = "_nm-5";
export var message = "_nm-c";
export var profilePicture = "_nm-e";
export var quillToolbarContainer = "_nm-f";
export var senderDate = "_nm-g";
export var senderDateCustomer = "_nm-h";
export var senderName = "_nm-d";
export var time = "_nm-k";
export var uploadedImage = "_nm-l";
export var username = "_nm-m";
export var xsmall = "_nm-n";